export default "__VITE_ASSET__cDC3WVMk__"